import { bootstrap } from '@energywebfoundation/generic-green-proofs-ui';
import { frontendConfiguration } from '@gp4ev/configuration-frontend';

bootstrap(frontendConfiguration);
